module.exports = "/fonts/ebupot-logotype-d-99e3d10f5b5fefe59b099e91078978f0.svg";